import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46d46266"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "course-modules" }
const _hoisted_2 = { class: "course-modules__head" }
const _hoisted_3 = { class: "lp-heading course-modules__title" }
const _hoisted_4 = {
  class: "course-modules__tabs",
  role: "tablist"
}
const _hoisted_5 = ["aria-selected", "onClick"]
const _hoisted_6 = { class: "course-modules__count" }
const _hoisted_7 = { class: "course-module__node" }
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = { class: "course-module__lessons" }
const _hoisted_10 = { class: "course-module__info" }
const _hoisted_11 = { class: "course-module__top" }
const _hoisted_12 = { class: "course-module__number" }
const _hoisted_13 = {
  key: 0,
  class: "course-module__description"
}
const _hoisted_14 = { class: "course-module__lessons-inline" }
const _hoisted_15 = {
  key: 0,
  class: "course-modules__empty"
}

import { computed, ref } from 'vue';
import HcIcon from '@/modern/components/ui/HcIcon.vue';
import { FALLBACK_IMAGE, ICourseModule, ModuleStatus, useCourseI18n } from './course';

type Filter = 'all' | ModuleStatus;

export default /*#__PURE__*/_defineComponent({
  props: {
    modules: null,
    currentModuleId: null
  },
  setup(__props: any) {

const props = __props as {
  modules: ICourseModule[]
  currentModuleId: number | null
}



const { tc } = useCourseI18n();

const filter = ref<Filter>('all');

const numbered = computed(() => props.modules.map((module, index) => ({ module, number: index + 1 })));

const filters = computed(() => ([
  { key: 'all' as Filter, label: tc('filter_all'), count: props.modules.length },
  { key: 'in_progress' as Filter, label: tc('filter_doing'), count: props.modules.filter(m => m.module_status === 'in_progress').length },
  { key: 'not_started' as Filter, label: tc('filter_todo'), count: props.modules.filter(m => m.module_status === 'not_started').length },
  { key: 'completed' as Filter, label: tc('filter_done'), count: props.modules.filter(m => m.module_status === 'completed').length },
]));

const visible = computed(() =>
  filter.value === 'all' ? numbered.value : numbered.value.filter(({ module }) => module.module_status === filter.value)
);

const STATUS_TAG: Record<ModuleStatus, { tone: string, key: string }> = {
  completed: { tone: 'green', key: 'status_done' },
  in_progress: { tone: 'purple', key: 'status_doing' },
  not_started: { tone: 'grey', key: 'status_todo' },
};

const lessonsLabel = (count: number) => count === 1 ? tc('lesson_count') : tc('lessons_count', { n: count });

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(tc)('modules_title')), 1),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filters), (item) => {
          return (_openBlock(), _createElementBlock("button", {
            key: item.key,
            type: "button",
            role: "tab",
            "aria-selected": filter.value === item.key,
            class: _normalizeClass(["course-modules__tab", { 'course-modules__tab--active': filter.value === item.key }]),
            onClick: ($event: any) => (filter.value = item.key)
          }, [
            _createTextVNode(_toDisplayString(item.label) + " ", 1),
            _createElementVNode("span", _hoisted_6, _toDisplayString(item.count), 1)
          ], 10, _hoisted_5))
        }), 128))
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["course-modules__list", { 'course-modules__list--timeline': filter.value === 'all' }])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(visible), ({ module, number }) => {
        return (_openBlock(), _createElementBlock("article", {
          key: module.id,
          class: _normalizeClass(["lp-card course-module", [`course-module--${module.module_status}`, { 'course-module--current': module.id === __props.currentModuleId }]])
        }, [
          _createElementVNode("span", _hoisted_7, [
            (module.module_status === 'completed')
              ? (_openBlock(), _createBlock(HcIcon, {
                  key: 0,
                  name: "check",
                  size: 18
                }))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(number), 1)
                ], 64))
          ]),
          _createVNode(_component_router_link, {
            to: { name: 'training-module-show', params: { id: module.id } },
            class: "course-module__thumb"
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: module.image_url || _unref(FALLBACK_IMAGE),
                alt: module.title,
                loading: "lazy"
              }, null, 8, _hoisted_8),
              _createElementVNode("span", _hoisted_9, [
                _createVNode(HcIcon, {
                  name: "video",
                  size: 13
                }),
                _createTextVNode(_toDisplayString(lessonsLabel(module.lessons_count)), 1)
              ])
            ]),
            _: 2
          }, 1032, ["to"]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(tc)('module_label', { n: number })), 1),
              _createElementVNode("span", {
                class: _normalizeClass(["lp-tag", `lp-tag--${STATUS_TAG[module.module_status]?.tone || 'grey'}`])
              }, _toDisplayString(_unref(tc)(STATUS_TAG[module.module_status]?.key || 'status_todo')), 3)
            ]),
            _createVNode(_component_router_link, {
              to: { name: 'training-module-show', params: { id: module.id } },
              class: "course-module__name"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(module.title), 1)
              ]),
              _: 2
            }, 1032, ["to"]),
            (module.description)
              ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(module.description), 1))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_14, [
              _createVNode(HcIcon, {
                name: "video",
                size: 13
              }),
              _createTextVNode(_toDisplayString(lessonsLabel(module.lessons_count)), 1)
            ])
          ]),
          _createVNode(_component_router_link, {
            to: { name: 'training-module-show', params: { id: module.id } },
            class: _normalizeClass(["lp-btn lp-btn--sm course-module__action", {
            'lp-btn--ghost': module.module_status === 'completed',
            'lp-btn--outline': module.module_status === 'not_started' && module.id !== __props.currentModuleId,
          }])
          }, {
            default: _withCtx(() => [
              (module.module_status === 'completed')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(HcIcon, {
                      name: "rotate",
                      size: 15
                    }),
                    _createTextVNode(_toDisplayString(_unref(tc)('review')), 1)
                  ], 64))
                : (module.module_status === 'in_progress')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_unref(tc)('continue')), 1),
                      _createVNode(HcIcon, {
                        name: "arrow",
                        size: 15
                      })
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createTextVNode(_toDisplayString(_unref(tc)('start')), 1)
                    ], 64))
            ]),
            _: 2
          }, 1032, ["to", "class"])
        ], 2))
      }), 128)),
      (!_unref(visible).length)
        ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_unref(tc)('empty_filter')), 1))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}
}

})